import { cn } from "@/lib/utils";

export const MARKDOWN_PREVIEW_BOLD_CLASS = "font-bold";

export const MARKDOWN_PREVIEW_ITALIC_CLASS = "italic";

export const MARKDOWN_PREVIEW_VARIABLE_CLASS = cn(
  "mx-0.5 rounded-sm bg-secondary px-2 py-0.5 text-sm",
  "text-secondary-foreground",
);

export const MARKDOWN_PREVIEW_HR_TEXT_CLASS = "text-border";

export const MARKDOWN_PREVIEW_LIST_LINE_CLASS = "ps-1";

/** ProseMirror list/HR chrome for WYSIWYG (Tailwind preflight resets list markers). */
export const MARKDOWN_PREVIEW_PROSEMIRROR_LIST_CLASS = cn(
  "[&_hr]:my-2 [&_hr]:border-0 [&_hr]:border-b [&_hr]:border-border",
  "[&_ul]:list-disc [&_ul]:pl-6",
  "[&_ol]:list-decimal [&_ol]:pl-6",
  "[&_li]:list-item",
);
